import axios, { AxiosInstance } from 'axios'


import handleError from '../utils/handleError'

export const API_URL = window.location.hostname === 'localhost' || window.location.hostname === 'antagonista-v3.ddev.site' ?
	process.env.REACT_APP_BASE_URL_LOCAL : window.location.hostname === 'registre-staging.oantagonista.com.br' ?
		process.env.REACT_APP_BASE_URL_STAGING : process.env.REACT_APP_BASE_URL;

const axiosInstance: AxiosInstance = axios.create({
	baseURL: `${API_URL}`,
	timeout: 300000
	// headers: { 'Content-Type': 'application/json' }
})

axiosInstance.interceptors.request.use(
	(request) => {
		if (process.env.NODE_ENV === 'development') {
			/**
			 * The react-query calling a request does't necessary mean that
			 * will make that number of request or even is going to make a request
			 * look at google chrome network to really see when a request is really made.
			 */
		}

		return request
	},
	(err) => {
		handleError(err)
		throw err
	}
)

axiosInstance.interceptors.response.use(
	(response) => {

		return response
	},
	(err) => {
		handleError(err)
		throw err
	}
)

export default axiosInstance
